import { toast } from "react-toastify";
import * as S from "./styles";
import InputMask from "react-input-mask";
import { useEffect } from "react";
import {
  allowsNegative,
  decimalInputAttrs,
  normalizeDecimalEvent,
} from "../../../Services/decimalInput";

interface IProps {
  autoComplete?: "on" | "off";
  type?:
    | "string"
    | "number"
    | "date"
    | "text"
    | "email"
    | "password"
    | "checkbox";
  placeholder?: string;
  maxLength?: number;
  label?: string;
  step?: string;
  min?: string;
  max?: string;
  disabled?: boolean;
  isInvalid?: boolean;
  size?: "sm" | "lg";
  as?: any;
  rows?: number;
  name: string;
  mask?: string;
  defaultValue?: any;
  errors?: any;
  register: any;
  watch?: any;
  setValue?: any;
  minWidth?: string | undefined;
}

export function InputHookFlex({
  label,
  type,
  autoComplete,
  placeholder,
  maxLength,
  step,
  min,
  max,
  disabled,
  as,
  rows,
  name,
  mask,
  defaultValue,
  register,
  errors,
  watch,
  setValue,
  minWidth,
}: IProps) {
  const errorToDisplay = errors
    ? Object?.keys(errors[0])?.find((key) => key === name)
    : "";

  // Não controlado (register): o campo mostra o valor já normalizado, com ponto.
  const isDecimal = type === "number";
  const registered = register(name);

  return (
    <S.Input
      errorToDisplay={
        errorToDisplay && errors[0][errorToDisplay]?.message.length > 0
      }
      minWidth={minWidth}
    >
      <label className="">{label}</label>
      {mask ? (
        <InputMask
          className="inputMask"
          {...register(name)}
          mask={mask}
          defaultValue={defaultValue}
          name={name}
          type="text"
          disabled={disabled}
          autoComplete="off"
          placeholder={placeholder}
          step={step}
          min={min}
          max={max}
        />
      ) : (
        <S.FormInput
          {...registered}
          onChange={(e: any) => {
            if (isDecimal) normalizeDecimalEvent(e, allowsNegative(min));
            return registered.onChange(e);
          }}
          defaultValue={defaultValue}
          name={name}
          as={as}
          type={isDecimal ? decimalInputAttrs.type : type}
          inputMode={isDecimal ? decimalInputAttrs.inputMode : undefined}
          autoComplete={autoComplete}
          placeholder={placeholder}
          maxLength={maxLength}
          step={step}
          min={min}
          max={max}
          disabled={disabled}
          rows={rows}
        />
      )}
      {errorToDisplay && (
        <S.Error>{errors[0][errorToDisplay]?.message}</S.Error>
      )}
    </S.Input>
  );
}
